import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISiteControlModel } from '../models'

export class UpdateSiteControlApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/siteControlUpdate',
      requesterInfo,
    })
  }

  public async siteControlUpdate(req: ISiteControlModel): Promise<ISiteControlModel> {
    return await this.postAsync<ISiteControlModel>(req)
  }
}
